import { motion } from "framer-motion";
import { PACKAGE_IMAGES } from "@/lib/api";

export default function Gallery() {
    return (
        <section
            id="galerie"
            className="relative py-24 md:py-32 px-6 md:px-12"
            data-testid="gallery-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
                    <div>
                        <span className="font-body text-xs uppercase tracking-[0.25em] text-zinc-500">
                            Galerie
                        </span>
                        <h2 className="mt-4 font-display text-4xl md:text-5xl font-light tracking-tight text-white leading-[1.1]">
                            L'intérieur du studio.
                        </h2>
                    </div>
                    <p className="max-w-md text-sm text-zinc-500 font-body">
                        Cadre chaleureux, acoustique maîtrisée — pensé pour une écoute qui donne envie de rester.
                    </p>
                </div>

                <div className="grid md:grid-cols-5 gap-4 md:gap-6">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.98 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="relative md:col-span-3 rounded-3xl overflow-hidden border border-white/10 bg-black group"
                    >
                        <img
                            src={PACKAGE_IMAGES.studio}
                            alt="Salle d'enregistrement"
                            className="w-full h-auto md:h-[520px] md:object-cover object-contain group-hover:scale-[1.02] transition-transform duration-1000"
                        />
                        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />
                        <div className="absolute bottom-6 left-6 flex items-center gap-3">
                            <span className="w-2 h-2 rounded-full bg-red-500 pulse-dot" />
                            <span className="font-body text-xs uppercase tracking-[0.3em] text-amber-300">
                                Lounge · MON SERAPHIN STUDIO
                            </span>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.98 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="relative md:col-span-2 rounded-3xl overflow-hidden border border-white/10 bg-black group"
                    >
                        <img
                            src={PACKAGE_IMAGES.lounge}
                            alt="Salle d'enregistrement"
                            className="w-full h-auto md:h-[520px] md:object-cover object-contain group-hover:scale-[1.02] transition-transform duration-1000"
                        />
                        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/80 to-transparent pointer-events-none" />
                        <div className="absolute bottom-6 left-6">
                            <span className="font-body text-xs uppercase tracking-[0.3em] text-amber-300">
                                Salle d'enregistrement — ON AIR
                            </span>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
